<template>
  <div>
    <wc-dialog
      :showDialog='showDialog'
      :title='$store.state.icons.dataBox.crewVisits.title'
      :icon='$store.state.icons.dataBox.crewVisits.icon'
      :loading='isLoading'
      width='500'
      hideCancel
      saveText='Close'
      @save="$emit('close')"
    >
      <template v-slot:dialog-form>
        <div v-if='wo || project'>
          <v-card flat v-if='visits.length === 0'>
            <v-card-text>
              {{ isLoading ? "Loading..." : "No visits found."}}
            </v-card-text>
          </v-card>
          <template v-for='(v, index) in sortedVisits'>
            <v-divider v-if='index > 0' :key='v.id'></v-divider>
            <v-card flat :key="index + '-' + v.id">
              <v-card-subtitle class='pb-2 d-flex align-baseline'>
                <wc-avatar :profile='v.created_by_obj'></wc-avatar>
                <span class='mx-2 heading-6'>{{ v.date | shortDate }}</span>
                <small>{{ v.time | time }}</small>
                <v-spacer></v-spacer>
                <span class='text-right'><v-chip label class='mr-2' v-if='v.is_attempted' xSmall color='warning'>Attempted</v-chip></span>
              </v-card-subtitle>
              <v-card-text>
                <span class='black--text'>{{ v.notes }}</span>
              </v-card-text>
            </v-card>
          </template>
        </div>
      </template>
    </wc-dialog>
  </div>
</template>

<!-- If making changes to this component - be sure to also update the CrewVisits component in wos/views/woDetail -->

<script>
import scheduleAPI from '@/modules/schedule/api/schedule'
import projectsAPI from '@/modules/projects/api/projects'
import _ from 'lodash'

export default {
  name: 'wo-crew-visits',
  props: {
    wo: {
      required: false
    },
    project: {
      required: false
    },
    showDialog: {
      required: true
    }
  },
  data () {
    return {
      isLoading: true,
      visits: []
    }
  },
  watch: {
    showDialog () {
      if (this.showDialog) {
        this.getData()
      }
    }
  },
  computed: {
    sortedVisits () {
      return _.orderBy(this.visits, ['date', 'time'], ['desc', 'desc'])
    }
  },
  methods: {
    async getData () {
      this.isLoading = true
      if (this.wo) {
        this.visits = await scheduleAPI.getCrewVisitsForWO(this.wo)
      } else if (this.project) {
        this.visits = await projectsAPI.getCrewVisitsForProject(this.project.id)
      }
      this.isLoading = false
    }
  }
}
</script>
